import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CircleCheckSvg = function CircleCheckSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "m10.942 17.201 6.035-7.466-1.157-.916-5.077 6.282-2.659-2.256-.964 1.113z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2.816a10.05 10.05 0 0 0-7.071 2.9A9.85 9.85 0 0 0 2 12.713a9.85 9.85 0 0 0 2.929 6.999 10.05 10.05 0 0 0 7.071 2.9c2.652 0 5.196-1.044 7.071-2.9A9.85 9.85 0 0 0 22 12.714a9.85 9.85 0 0 0-2.929-6.999A10.05 10.05 0 0 0 12 2.816M5.977 6.752A8.56 8.56 0 0 1 12 4.282c2.26 0 4.426.889 6.023 2.47a8.39 8.39 0 0 1 2.496 5.962c0 2.236-.898 4.38-2.495 5.962A8.56 8.56 0 0 1 12 21.146a8.56 8.56 0 0 1-6.023-2.47 8.39 8.39 0 0 1-2.496-5.962c0-2.236.898-4.38 2.496-5.962",
      clipRule: "evenodd"
    })]
  });
};
export var CircleCheck = function CircleCheck(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: CircleCheckSvg
  }));
};